/**
 * SegmentedControl — Clickable chip-select buttons.
 *
 * Each button has a data-value attribute. The active button is highlighted,
 * others are muted. Clicking sets the filter value via UIBridge.
 */
export default class SegmentedControl {
  constructor(bridge, filterName, containerSelector, config) {
    this.bridge = bridge;
    this.filterName = filterName;
    this.container = document.querySelector(containerSelector);
    this.values = config.values;

    if (!this.container) {
      console.warn(`SegmentedControl: container not found for ${filterName}`);
      return;
    }

    this.buttons = this.container.querySelectorAll('.segment-btn');
    this._init();

    bridge.register(filterName, {
      nativeSelector: config.nativeSelector || `.${filterName}`,
      type: 'select',
      onNativeChange: (value) => this._onCascadeUpdate(value)
    });
  }

  _init() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.dataset.value;
        const idx = this.values.indexOf(value);
        if (idx !== -1) {
          this._setActive(idx);
          this.bridge.setFilterValue(this.filterName, this.values[idx]);
        }
      });
    });
  }

  _setActive(activeIdx) {
    this.buttons.forEach((btn, idx) => {
      btn.classList.toggle('active', idx === activeIdx);
    });
  }

  _onCascadeUpdate(value) {
    const idx = this.values.indexOf(value);
    if (idx !== -1) {
      this._setActive(idx);
    } else {
      // Partial match fallback
      for (let i = 0; i < this.values.length; i++) {
        if (value.includes(this.values[i]) || this.values[i].includes(value)) {
          this._setActive(i);
          break;
        }
      }
    }
  }
}
